import { ButtonVariant } from '../../atoms/button/button';
import { CtaAction, CtaVariant } from './cta-block';

/**
 * Adapts a cta-section. The Strapi shape has a section wrapper
 * with a nested `ctaBlock` component containing the CTA content.
 * Also handles direct cta-block shape (extraSections).
 */
export function adaptCtaBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  // CTA data can come from:
  // 1. entry.ctaBlock (named section with nested component)
  // 2. entry directly (cta-block in extraSections)
  const ctaBlock = entry['ctaBlock'] as Record<string, unknown> | undefined;
  const source = ctaBlock ?? entry;

  const rawActions = source['actions'];
  const actions: CtaAction[] = Array.isArray(rawActions)
    ? rawActions.map(
        (a: Record<string, unknown>) =>
          ({
            label: (a['label'] as string) ?? '',
            href: (a['href'] as string) ?? (a['url'] as string) ?? '#',
            variant: ((a['variant'] as string) ?? 'primary') as ButtonVariant,
          }) satisfies CtaAction,
      )
    : [];

  return {
    heading: (source['heading'] as string) ?? (entry['heading'] as string) ?? '',
    subtitle: (source['subtitle'] as string) ?? (source['description'] as string) ?? '',
    variant: (source['variant'] as CtaVariant) ?? 'dark',
    actions,
    escapeText: (source['escapeText'] as string) ?? '',
    escapeHref: (source['escapeHref'] as string) ?? '',
  };
}
